export enum MenuKey {
  Booking = 1,
  Travels,
  Expenses,
  Profile,
  Dashboard,
  Users,
  Groups,
  Rules,
  CostCenter,
  Report,
  Settings,
  CustomerSupport,
  BranchCompany,
  ResellerCustomization,
  WhatsApp,
  AllReservationsReport,
  CompanyConfigurationUpdate,
  AdminTools,
}

export enum MenuRoles {
  Traveler = 1,
  Approver,
  Admin,
  TravelArranger,
  SuperAdmin,
  SupportImplementation
}

export enum MenuDisplay {
  Mobile = 1,
  Desktop,
}

export interface MenuEntry {
  key: MenuKey;
  mainRoute: string;
  nestedRoutes: string[];
  roles: MenuRoles[];
  display: MenuDisplay[];
  iconSrc: string;
  iconSmall: boolean;
  name: string;
  detail: string;
  hide: boolean; 
}

const MENU_ENTRIES: MenuEntry[] = [
  {
    key: MenuKey.Booking,
    mainRoute: '/corporate/booking',
    nestedRoutes: ['/corporate/flights', '/corporate/hotels', '/corporate/autos'],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/booking.svg',
    iconSmall: false,
    name: 'userMenu.bookingTitle',
    detail: 'userMenu.bookingDetail',
    hide: false,
  },
  {
    key: MenuKey.Travels,
    mainRoute: '/corporate/travelRequested',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/mytrips.svg',
    iconSmall: false,
    name: 'userMenu.myTripsTitle',
    detail: 'userMenu.myTripsDetail',
    hide: false,
  },
  {
    key: MenuKey.Expenses,
    mainRoute: '/corporate/travelsWithExpenses',
    nestedRoutes: ['/expense', '/expenses'],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/reports.svg',
    iconSmall: true,
    name: 'userMenu.expensesTitle',
    detail: 'userMenu.expensesDetail',
    hide: false,
  },
  {
    key: MenuKey.Profile,
    mainRoute: '/corporate/travelerProfile',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile],
    iconSrc: '/corporate/images/users.svg',
    iconSmall: true,
    name: 'userMenu.travelerProfileTitle',
    detail: 'userMenu.travelerProfileDetail',
    hide: false,
  },
  {
    key: MenuKey.CustomerSupport,
    mainRoute: '/corporate/customerSupport',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile],
    iconSrc: '/corporate/images/customer-support.svg',
    iconSmall: true,
    name: 'userMenu.customerSupportTitle',
    detail: 'userMenu.customerSupportDetail',
    hide: false,
  },
  {
    key: MenuKey.Dashboard,
    mainRoute: '/corporate/dashboard',
    nestedRoutes: [
      '/corporate/requestHistory',
      '/corporate/dashboardReports',
      '/corporate/dashboardReports/reportDetail',
    ],
    roles: [MenuRoles.Approver, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/dashboard-icon.svg',
    iconSmall: false,
    name: 'userMenu.dashboardTitle',
    detail: 'userMenu.dashboardDetail',
    hide: false,
  },
  {
    key: MenuKey.Users,
    mainRoute: '/corporate/usersList',
    nestedRoutes: ['/corporate/usersForm'],
    roles: [MenuRoles.Admin, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/check-copy.svg',
    iconSmall: true,
    name: 'userMenu.usersProfilesTitle',
    detail: 'userMenu.usersProfilesDetail',
    hide: false,
  },
  {
    key: MenuKey.BranchCompany,
    mainRoute: '/corporate/billingCompanyList',
    nestedRoutes: ['/billingCompany'],
    roles: [MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/document.svg',
    iconSmall: true,
    name: 'userMenu.billingCompanyTitle',
    detail: 'userMenu.billingCompanyDetail',
    hide: false,
  },
  /*{
    key: MenuKey.AllReservationsReport,
    mainRoute: '/corporate/allReservationsReport',
    nestedRoutes: ['/allReservationsReport'],
    roles: [MenuRoles.SuperAdmin, MenuRoles.Admin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/reports.svg',
    iconSmall: true,
    name: 'userMenu.allReservationsReportTitle',
    detail: 'userMenu.allReservationsReportDetail',
    hide: false,
  },
  {
    key: MenuKey.ResellerCustomization,
    mainRoute: '/corporate/resellerCustomization',
    nestedRoutes: [],
    roles: [MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/paint-pallete.svg',
    iconSmall: false,
    name: 'userMenu.resellerCustomizationTitle',
    detail: 'userMenu.resellerCustomizationDetail',
    hide: false,
  },*/{
    key: MenuKey.AdminTools,
    mainRoute: '/corporate/admintool',
    nestedRoutes: [],
    roles: [MenuRoles.SupportImplementation],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/settings.svg',
    iconSmall: true,
    name: 'userMenu.resellerAdminToolTitle',
    detail: 'userMenu.resellerAdminToolDetail',
    hide: false,
  },
  /*{
    key: MenuKey.CompanyConfigurationUpdate,
    mainRoute: '/corporate/companyConfigurationUpdate',
    nestedRoutes: [],
    roles: [MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/customer-support.svg',
    iconSmall: false,
    name: 'userMenu.companyConfigurationUpdateTitle',
    detail: 'userMenu.companyConfigurationUpdateDetail',
    hide: false,
  },*/
  {
    key: MenuKey.Groups,
    mainRoute: '/corporate/groupList',
    nestedRoutes: ['/corporate/group'],
    roles: [MenuRoles.Admin, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/people.svg',
    iconSmall: true,
    name: 'userMenu.groupsTitle',
    detail: 'userMenu.groupsDetail',
    hide: false,
  },
  {
    key: MenuKey.Rules,
    mainRoute: '/corporate/rules',
    nestedRoutes: ['/corporate/rule'],
    roles: [MenuRoles.Admin, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/polices.svg',
    iconSmall: true,
    name: 'userMenu.rulesTitle',
    detail: 'userMenu.rulesDetail',
    hide: false,
  },
  {
    key: MenuKey.CostCenter,
    mainRoute: '/corporate/costCenterList',
    nestedRoutes: ['/corporate/costCenter'],
    roles: [MenuRoles.Admin, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/rules.svg',
    iconSmall: true,
    name: 'userMenu.costCenterTitle',
    detail: 'userMenu.costCenterDetail',
    hide: false,
  },
  {
    key: MenuKey.AllReservationsReport,
    mainRoute: '/corporate/allReservationsReport',
    nestedRoutes: [],
    roles: [MenuRoles.Admin, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/corporate/images/reports.svg',
    iconSmall: true,
    name: 'userMenu.reportsTitle',
    detail: 'userMenu.reportsDetail',
    hide: false,
  },
  {
    key: MenuKey.Settings,
    mainRoute: '/corporate/settings',
    nestedRoutes: [],
    roles: [MenuRoles.Admin, MenuRoles.SuperAdmin],
    display: [MenuDisplay.Mobile],
    iconSrc: '/corporate/images/settings.svg',
    iconSmall: true,
    name: 'userMenu.settingsTitle',
    detail: 'userMenu.settingsDetail',
    hide: false,
  },
  {
    key: MenuKey.WhatsApp,
    mainRoute: '/corporate/customerSupport',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile],
    iconSrc: '/corporate/images/whatsapp-menu-mobile.svg',
    iconSmall: true,
    name: 'userMenu.whatsAppTitle',
    detail: 'userMenu.whatsAppDetail',
    hide: false,
  },
];

export default MENU_ENTRIES.filter((item) => item.hide !== true);
